import * as React from 'react';
import { useSelector } from 'react-redux';

import { EPanelSide, NewbuildingHeaderPanel } from '../../components/NewbuildingHeaderPanel';
import { NewbuildingHeaderWrapper } from '../../components/NewbuildingHeaderWrapper';
import { getNewbuildingHeaderData } from '../../selectors/newbuildingHeader';
import { Breadcrumbs } from '../../serp/components/Breadcrumbs';
import { NewbuildingFlatTourBookingNotificationContainer } from '../NewbuildingFlatTourBookingNotification';
import { NewbuildingHeaderInformationContainer } from '../NewbuildingHeaderInformation';
import { NewbuildingHeaderMediaContainer } from '../NewbuildingHeaderMedia';
import { NewbuildingHeaderSeoContainer } from '../NewbuildingHeaderSeo';
import { NewbuildingHeaderServicesContainer } from '../NewbuildingHeaderServices';

const HeaderNewbuildingRedesignedContainer: React.FC = () => {
  const { breadcrumbs } = useSelector(getNewbuildingHeaderData);

  return (
    <NewbuildingHeaderWrapper>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <NewbuildingHeaderPanel side={EPanelSide.Left}>
        <NewbuildingHeaderSeoContainer />
        <NewbuildingHeaderInformationContainer />
        <NewbuildingHeaderServicesContainer />
      </NewbuildingHeaderPanel>
      <NewbuildingHeaderPanel side={EPanelSide.Right}>
        <NewbuildingHeaderMediaContainer />
      </NewbuildingHeaderPanel>
      <NewbuildingFlatTourBookingNotificationContainer />
    </NewbuildingHeaderWrapper>
  );
};

// oxlint-disable-next-line import/no-default-export
export default HeaderNewbuildingRedesignedContainer;
